import React, { useContext, useEffect, useState } from "react";
import { putData } from "../../lib/utils";
import { Context } from "../contexts/AppContext";
function DomainSetting() {


     const { value } = useContext(Context);
     
        const [appState, setAppState] = value;
  const [domain, setDomain] = useState(""); // input ka value
  const [savedDomain, setSavedDomain] = useState(""); // jo domain add hoga

  useEffect(()=>{
setSavedDomain(appState?.adminDetails?.domainurl)
  },[appState?.adminDetails?.domainurl])
const handleAddDomain = async () => {
  console.log("app state ",appState)
    if (domain.trim() !== "" && appState?.adminDetails?.id) {
      try {
        const obj = { domainurl: domain.trim() };

        const res = await putData(`admin/update-domain/${appState?.adminDetails?.id}`, obj);

        if (res) {
          console.log("reposne... ",res)
          setSavedDomain(domain.trim());
          setDomain(""); // input clear
        }
      } catch (error) {
        console.error("Error updating domain:", error);
      }
    }
  };

  const handleRemoveDomain = async() => {
    setSavedDomain("");
    const obj={
      domainurl:null
    }
      const res = await putData(`admin/update-domain/${appState?.adminDetails?.id}`, obj);

        if (res) {
          console.log("reposne... ",res)
            setSavedDomain("");
          setDomain(""); // input clear
        }
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 text-left">
        {/* Left Section */}
        <div className="bg-white rounded-2xl shadow-md border">
          <div className="p-5 border-b">
            <h2 className="text-lg font-semibold">Custom Domain</h2>
            <p className="text-sm text-gray-500">
              Use your own custom domain for your client galleries:
            </p>
          </div>
          <div className="p-5">
            <div className="border p-4 rounded-lg">
              {savedDomain ? (
                <>
                  {/* Domain Active UI */}
                  <div className="text-lg font-medium">{savedDomain}</div>

                  <div className="flex items-center justify-between mt-3 p-3 border rounded-lg bg-green-50">
                    <div>
                      <p className="font-medium text-green-700">
                        Your domain is active.
                      </p>
                      <p className="text-sm text-gray-500">
                        DNS changes can take up to 48 hours to propagate across
                        the entire internet.
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={handleRemoveDomain}
                    className="mt-4 w-full border border-red-500 text-red-600 rounded-lg py-2 hover:bg-red-50 transition"
                  >
                    Remove Domain
                  </button>
                </>
              ) : (
                <>
                  {/* Input + Add Domain UI */}
                  <input
                    type="text"
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                    placeholder="Enter your domain"
                    className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    onClick={handleAddDomain}
                    className="mt-3 w-full bg-gray-600 text-white rounded-lg py-2 hover:bg-gray-700 transition"
                  >
                    Add Domain
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Right Section */}
       <div className="bg-white rounded-2xl shadow-md border p-5 lg:col-span-2 overflow-y-auto h-screen">
  <div className="mb-2 font-semibold">DOMAIN SETUP GUIDE</div>

  <p className="text-sm text-gray-500 mb-4">
    Follow the steps below to connect your custom domain with your gallery.
  </p>

  <section className="w-full mx-auto">
    <div className="bg-white rounded-lg">

      {/* Title */}
      <h1 className="text-2xl font-bold mb-4">
        Connect Your Custom Domain
      </h1>

      {/* Intro */}
      <p className="mb-3">
        You can use your own domain name to access your gallery. This allows you
        to create a more professional and branded experience for your users.
      </p>

      <p className="mb-4">
        If you don’t already own a domain, you can purchase one from providers
        like GoDaddy, Namecheap, or Google Domains.
      </p>

      {/* Info box */}
      <div className="border-l-4 border-blue-500 pl-4 mb-5 text-gray-700">
        Some features may require additional setup or add-ons depending on your plan.
      </div>

      {/* Step 1 */}
      <h3 className="text-lg font-semibold mt-6">
        Step 1: Access your domain settings
      </h3>
      <p className="mt-2 text-gray-600">
        Log in to your domain provider account and navigate to DNS or domain
        management settings.
      </p>

      <div className="border-l-4 border-yellow-500 pl-4 my-4 text-sm text-gray-600">
        ⚠️ Avoid modifying email-related records (MX records), as this may affect your email services.
      </div>

      <hr className="my-6" />

      {/* Step 2 */}
      <h3 className="text-lg font-semibold">
        Step 2: Add a CNAME record
      </h3>

      <p className="mt-2 text-gray-600">
        Create a new CNAME entry using the following details:
      </p>

      <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
        <li>Record Type: CNAME</li>
        <li>Host/Name: Choose any subdomain (e.g. gallery, client)</li>
        <li>Target: your platform domain (provided in your dashboard)</li>
        <li>TTL: Default or lowest available</li>
      </ul>

      <p className="mt-4 font-medium">Example subdomains:</p>
      <ul className="list-disc list-inside text-gray-600">
        <li>gallery.yourdomain.com</li>
        <li>client.yourdomain.com</li>
        <li>media.yourdomain.com</li>
      </ul>

      <hr className="my-6" />

      {/* Step 3 */}
      <h3 className="text-lg font-semibold">
        Step 3: Add domain in your dashboard
      </h3>

      <p className="mt-2 text-gray-600">
        Go to your account settings and enter the same domain you created in the previous step.
      </p>

      <p className="mt-2 text-gray-600">
        Save the domain and run the verification process to confirm the setup.
      </p>

      <p className="mt-2 text-gray-600">
        Once verified, your domain will be marked as active.
      </p>

      {/* Note */}
      <div className="border-l-4 border-gray-400 pl-4 my-6 text-gray-600 italic">
        DNS updates may take some time to reflect globally. Please allow up to 24–48 hours.
      </div>

      {/* Footer */}
      <div className="mt-6 border-t pt-4 text-sm text-gray-600">
        <p>
          Need help?{" "}
          <span
            onClick={() => window.Beacon("open")}
            className="text-blue-600 cursor-pointer underline"
          >
            Contact Support
          </span>
        </p>
        <p className="text-xs mt-2">Last updated recently</p>
      </div>

    </div>
  </section>
</div>
      </div>
    </>
  );
}

export default DomainSetting;
